import { useState } from 'react'
import Swal from 'sweetalert2'
import { getArticuloPriceList, importPriceList } from '../../../Services/listaPrecioService'
import { listaPreciosExcel } from '../../../Services/reporteService'
import showImportResult, { showImportError } from '../../../utils/showImportResult'

const usePriceList = () => {
  const [file, setFile] = useState()
  const [isLoading, setIsLoading] = useState(false)

  //export:
  const handleExport = async () => {
    try {
      const priceLists = await getArticuloPriceList(true, 0, 50000)
      const excel = await listaPreciosExcel(priceLists.data.content, null)
      const byteCharacters = atob(excel.data)
      const byteNumbers = new Array(byteCharacters.length)

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'priceLists.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un problema al generar el archivo.',
        showConfirmButton: true,
      })
    }
  }

  //import:
  const handleImport = (e) => {
    e.preventDefault()

    const formData = new FormData()
    formData.append('file', file)

    setIsLoading(true)
    importPriceList(formData)
      .then((data) => {
        showImportResult(data, 'listas de precios')
      })
      .catch(() => {
        showImportError('listas de precios')
      })
      .finally(() => setIsLoading(false))
  }

  return {
    file,
    setFile,
    isLoading,
    handleImport,
    handleExport,
  }

}

export default usePriceList